<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Your Emails"></list-nav-header>


            <list-nav-scroll>
                <table class="responsive-table">
                    <thead>
                    <tr>
                        <th scope="col">Created At</th>
                        <th scope="col">Email Type</th>
                        <th scope="col">To</th>
                        <th scope="col">CC</th>
                        <th scope="col">Subject</th>
                        <th scope="col">Body</th>
                        <th scope="col">Attachments?</th>
                        <th scope="col">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Created At">{{ item.created_at }}</td>
                        <td data-label="Email Type">{{ item.email_type }}</td>
                        <td data-label="To" v-html="$options.filters.recipients(item.to)"></td>
                        <td data-label="CC" v-html="$options.filters.recipients(item.cc)"></td>
                        <td data-label="Subject">{{ item.subject }}</td>
                        <td data-label="Body"><a href="#" @click.prevent="showEmail(item)">{{ item.body | truncate(25,'...') }}</a></td>
                        <td data-label="Attachments?">{{ item.has_attachments | human_bool }}</td>
                        <td data-label="Status">{{ item.status }}</td>
                    </tr>
                    </tbody>
                </table>
                <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                    <span slot="no-more">
                      End Of Email List
                    </span>
                </infinite-loading>
            </list-nav-scroll>
        </list-nav>
        <show-email-modal></show-email-modal>
    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        data() {
            return {
                name: 'emails',
                items: [],
                nextPaginationUrl: '',
            }
        },
        filters: {
            recipients: function(arrayOfRecips){
                console.log(arrayOfRecips);
                return _.map(arrayOfRecips, function(recip){
                    return '<a href="mailto:'+recip.email+'">'+recip.name+'</a>';
                }).join(', ');
            }
        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        methods: {
            showEmail(email){
                window.eventBus.$emit('show-email-modal-open',email);
            },
            getItems() {
                var that = this;
                var url = appUrls.emails.index;
                var params = {};
                params.limit = 25;

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            this.getItems();
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
